import { EllipsisVertical } from 'lucide-react';

import { EditUpcomingTransaction } from '~features/students/ui/student-payment/edit-upcoming-transaction';

import { Button } from '~shared/shadcn/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~shared/shadcn/ui/dropdown-menu';

import { CancelInvoice } from './cancel-invoice';
import { RetryOrCollectPayment } from './retry-or-collect-payment';

interface ScheduledFailedInvoiceActionProps {
  transactionId: string;
  internalTransactionId: string;
  invoiceDate: string;
  status: 'scheduled' | 'failed' | 'invoice scheduled' | 'pending' | 'free' | 'invalid';
}

export const ScheduledFailedInvoiceAction = ({
  transactionId,
  internalTransactionId,
  invoiceDate,
  status,
}: ScheduledFailedInvoiceActionProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant='ghost'>
          <EllipsisVertical className='size-4' />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start'>
        <DropdownMenuGroup className='flex flex-col gap-2'>
          <DropdownMenuItem asChild>
            <EditUpcomingTransaction
              transactionId={transactionId}
              internalTransactionId={internalTransactionId}
            />
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <RetryOrCollectPayment
              invoiceId={transactionId}
              invoiceDate={invoiceDate}
              buttonText={
                status === 'failed' ||
                status === 'pending' ||
                status === 'invalid'
                  ? 'Reattempt Charge'
                  : 'Collect Payment'
              }
            />
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <CancelInvoice invoiceId={transactionId} />
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
